// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"84aef22d","231":"1a03004d","572":"5f0fc303","719":"e7fb3f82","835":"64ed202f","839":"862447e5"}[chunkId] + ".chunk.js";
};